module.exports = __webpack_public_path__ + "img/showcase-comparables-en-us.3d334bf3.jpg";